/**
 * File view component.
 * @module components/theme/View/FileView
 */

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import DateSocialShareBody from 'govbr.frontend.policy/components/Blocks/DateShare/DateSocialShareBody';
import { formatFileSize } from 'govbr.frontend.policy/helpers/formatFileSize';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';

/**
 * File view component class.
 * @function FileView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const FileView = ({ content }) => (
  <Container className="view-wrapper mb-3xh">
    <h1 className="documentFirstHeading">
      {content.title}
      {content.subtitle && ` - ${content.subtitle}`}
    </h1>
    {content.description && (
      <p className="documentDescription">{content.description}</p>
    )}
    <DateSocialShareBody properties={content} hideTag />
    <div className="mb-3x">
      {content.file?.download && (
        <UniversalLink href={content.file.download}>
          {content.file.filename}
        </UniversalLink>
      )}
      {content.file?.size && (
        <span className="text-down-01">
          &nbsp;&mdash;&nbsp;{formatFileSize(content.file.size)}
        </span>
      )}
    </div>
  </Container>
);

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
FileView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    file: PropTypes.shape({
      download: PropTypes.string,
      filename: PropTypes.string,
    }),
  }).isRequired,
};

export default FileView;
